export const TOKEN_TYPE = {
  GUEST: 1,
  USER: 2,
};
